import { render, staticRenderFns } from "./AfterUseWrite.vue?vue&type=template&id=4328e0f8&scoped=true"
import script from "./AfterUseWrite.vue?vue&type=script&lang=js"
export * from "./AfterUseWrite.vue?vue&type=script&lang=js"
import style0 from "./AfterUseWrite.vue?vue&type=style&index=0&id=4328e0f8&prod&lang=scss&scoped=true"
import style1 from "./AfterUseWrite.vue?vue&type=style&index=1&id=4328e0f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328e0f8",
  null
  
)

export default component.exports